export default "__VITE_ASSET__WQMfIX70__"